import { prefix } from "./constants.js";
import { createAction } from "typesafe-actions";
const replaceAssignmentUnit = createAction(`${prefix}/MERGE`, (action) => (result) => action(result));
const appendAssignmentUnit = createAction(`${prefix}/APPEND`, (action) => (result) => action(result));
export {
  appendAssignmentUnit,
  replaceAssignmentUnit
};
//# sourceMappingURL=actions.js.map
